export const URL_COOKIE_POLICY = "https://hallow.com/cookie-policy";
